import SpriteSymbol from "../../../../mobile/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-arrow-down",
  "use": "svg-icon-arrow-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg-icon-arrow-down\"><path fill=\"currentColor\" d=\"M8.8 15.42c-.54-.55-3.26-3.27-8.16-8.16l2.34-2.33 9.34 9.34-1.16 1.16c-1.14.43-1.93.42-2.36-.01z\" /><path fill=\"currentColor\" d=\"M8.85 15.43l-1.17-1.17 9.34-9.34 2.34 2.33-8.16 8.16c-1.13.44-1.91.45-2.35.02z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol